import ApiService from '@/services/CommonApiService.js'
import moment from 'moment'

export const namespaced = true
export const state = {
  pods: [],
  selectedPod: '',
  selectedDate: [
    moment().format('YYYY-MM-DD 00:00:00'),
    moment()
      .add(1, 'days')
      .format('YYYY-MM-DD 00:00:00')
  ],
  selectedUtcOffset: 'Australia/Sydney',
  selectedProductName: ''
}

export const mutations = {
  SET_PODS(state, value) {
    state.pods = value
  },
  SET_SELECTED_POD(state, value) {
    state.selectedPod = value
  },
  SET_SELECTED_DATE(state, value) {
    state.selectedDate = value
  },
  SET_SELECTED_UTC_OFFSET(state, value) {
    state.selectedUtcOffset = value
  },
  SET_SELECTED_PRODUCT_NAME(state, value) {
    state.selectedProductName = value
  }
}

export const actions = {
  fetchPods({ commit }) {
    return ApiService.GetConfiguration()
      .then(response => {
        commit('SET_PODS', response.data.pods)
        if (!this.state.pods.selectedPod && response.data.pods.length) {
          commit('SET_SELECTED_POD', response.data.pods[0])
        }
      })
      .catch(() => {
        //console.log('IN Catch: ')
      })
  }
}
